import _readOnlyError from "@babel/runtime/helpers/readOnlyError";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import './ModalTrigger.scss';
var ModalTrigger = /*#__PURE__*/function (_Component) {
  function ModalTrigger(props) {
    var _this;
    _classCallCheck(this, ModalTrigger);
    _this = _callSuper(this, ModalTrigger, [props]);
    _this.state = {
      showModal: props.showModal
    };
    _this.open = _this.open.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ModalTrigger, _Component);
  return _createClass(ModalTrigger, [{
    key: "close",
    value: function close() {
      var onCloseCallback = this.props.onCloseCallback;
      this.setState({
        showModal: false
      });
      onCloseCallback();
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        closeAfterSubmit = _this$props.closeAfterSubmit;
      (handleSubmit || this.close)();
      if (closeAfterSubmit) {
        this.close();
      }
    }
  }, {
    key: "open",
    value: function open(event) {
      event === null || event === void 0 ? void 0 : event.preventDefault();
      var _this$props2 = this.props,
        onClick = _this$props2.onClick,
        stopPropagation = _this$props2.stopPropagation;
      if (stopPropagation) event === null || event === void 0 ? void 0 : event.stopPropagation();
      onClick();
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "renderTrigger",
    value: function renderTrigger() {
      var _this$props3 = this.props,
        triggerType = _this$props3.triggerType,
        triggerText = _this$props3.triggerText,
        buttonStyles = _this$props3.buttonStyles,
        idKey = _this$props3.idKey,
        disabled = _this$props3.disabled,
        biggerButton = _this$props3.biggerButton;
      if (triggerType === 'link') {
        return /*#__PURE__*/React.createElement("a", {
          className: "modal-anchor-trigger ".concat(buttonStyles),
          tabIndex: 0,
          role: "button",
          onClick: this.open,
          id: "".concat(idKey, "-link"),
          disabled: disabled,
          href: "#modal-trigger-open"
        }, triggerText);
      }
      return /*#__PURE__*/React.createElement(Button, {
        variant: buttonStyles,
        className: "".concat(biggerButton ? 'bigger-button' : ''),
        onClick: this.open,
        id: "".concat(idKey, "-button"),
        disabled: disabled
      }, triggerText);
    }
  }, {
    key: "renderSubTitle",
    value: function renderSubTitle() {
      var subTitle = this.props.subTitle;
      if (subTitle !== '') {
        return /*#__PURE__*/React.createElement("h5", null, subTitle);
      }
      return null;
    }
  }, {
    key: "renderSubmit",
    value: function renderSubmit() {
      var _this$props4 = this.props,
        idKey = _this$props4.idKey,
        submitButtonText = _this$props4.submitButtonText,
        submitButtonStyle = _this$props4.submitButtonStyle,
        submitDisabled = _this$props4.submitDisabled,
        submitButtonNode = _this$props4.submitButtonNode;
      if (submitButtonNode === null) {
        return /*#__PURE__*/React.createElement(Fragment, null, submitButtonText && /*#__PURE__*/React.createElement(Button, {
          disabled: submitDisabled,
          variant: submitButtonStyle || 'primary',
          onClick: this.handleSubmit,
          id: "".concat(idKey, "-confirm")
        }, submitButtonText));
      }
      return submitButtonNode;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props5 = this.props,
        showFooter = _this$props5.showFooter,
        cancelButton = _this$props5.cancelButton,
        cancelButtonText = _this$props5.cancelButtonText,
        idKey = _this$props5.idKey,
        showWithdrawButton = _this$props5.showWithdrawButton,
        submitButtonText = _this$props5.submitButtonText,
        handleWithdrawApplication = _this$props5.handleWithdrawApplication;
      if (showFooter === true) {
        return /*#__PURE__*/React.createElement(Modal.Footer, {
          className: "style-guide d-flex justify-content-center"
        }, idKey === 'consultant-interest-application' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "footer-action"
        }, cancelButton && /*#__PURE__*/React.createElement(Button, {
          variant: "default",
          id: "".concat(idKey, "-close"),
          onClick: this.close
        }, cancelButtonText), (showWithdrawButton || submitButtonText === 'Submit application') && this.renderSubmit()), showWithdrawButton && /*#__PURE__*/React.createElement("div", {
          className: "footer-action"
        }, /*#__PURE__*/React.createElement(Button, {
          id: "btn-withdraw",
          variant: "danger",
          onClick: function onClick() {
            return handleWithdrawApplication();
          }
        }, "Withdraw"))) : /*#__PURE__*/React.createElement(Fragment, null, cancelButton && /*#__PURE__*/React.createElement(Button, {
          variant: "default",
          id: "".concat(idKey, "-close"),
          onClick: this.close
        }, cancelButtonText), this.renderSubmit()));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        headerTitle = _this$props6.headerTitle,
        showHeader = _this$props6.showHeader,
        idKey = _this$props6.idKey,
        animation = _this$props6.animation,
        dialogClassName = _this$props6.dialogClassName,
        cloneContent = _this$props6.cloneContent,
        children = _this$props6.children,
        modalSize = _this$props6.modalSize;
      var showModal = this.state.showModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "modal-trigger"
      }, this.renderTrigger(), /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.close,
        id: idKey,
        animation: animation,
        dialogClassName: dialogClassName,
        size: modalSize
      }, showHeader && /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement(Modal.Title, null, headerTitle), this.renderSubTitle()), /*#__PURE__*/React.createElement(Modal.Body, null, cloneContent ? /*#__PURE__*/React.cloneElement(children, {
        closeModal: this.close
      }) : children), this.renderFooter()));
    }
  }]);
}(Component);
ModalTrigger.propTypes = {
  submitButtonText: PropTypes.string,
  submitButtonStyle: PropTypes.string,
  cancelButton: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonStyles: PropTypes.string,
  headerTitle: PropTypes.string,
  subTitle: PropTypes.string,
  handleSubmit: PropTypes.func,
  submitDisabled: PropTypes.bool,
  triggerType: PropTypes.oneOf(['link', 'button']),
  children: PropTypes.node.isRequired,
  idKey: PropTypes.string.isRequired,
  showFooter: PropTypes.bool,
  showHeader: PropTypes.bool,
  animation: PropTypes.bool,
  disabled: PropTypes.bool,
  closeAfterSubmit: PropTypes.bool,
  biggerButton: PropTypes.bool,
  onCloseCallback: PropTypes.func,
  submitButtonNode: PropTypes.node,
  onClick: PropTypes.func,
  stopPropagation: PropTypes.bool,
  dialogClassName: PropTypes.string,
  cloneContent: PropTypes.bool,
  showModal: PropTypes.bool,
  showWithdrawButton: PropTypes.bool,
  handleWithdrawApplication: PropTypes.func,
  modalSize: PropTypes.string
};
ModalTrigger.defaultProps = {
  submitButtonText: '',
  submitButtonStyle: null,
  cancelButton: true,
  cancelButtonText: 'Close',
  triggerText: '',
  buttonStyles: '',
  headerTitle: '',
  subTitle: '',
  handleSubmit: null,
  submitDisabled: false,
  triggerType: 'button',
  showHeader: true,
  showFooter: true,
  animation: true,
  disabled: false,
  closeAfterSubmit: false,
  biggerButton: false,
  onCloseCallback: function onCloseCallback() {
    return null;
  },
  submitButtonNode: null,
  onClick: function onClick() {
    return null;
  },
  stopPropagation: false,
  dialogClassName: '',
  cloneContent: false,
  showModal: false,
  showWithdrawButton: false,
  handleWithdrawApplication: function handleWithdrawApplication() {},
  modalSize: 'lg'
};
export default ModalTrigger;